/* ============================================================
   ILS - Store-wide rating live patcher (TASK-2034).

   Replaces hardcoded store rating strings (e.g. sticky ATC marquee
   chips, home social-proof star item) with live values from
   GET {apiBase}/api/reviews/summary.

   Any element with [data-ils-store-rating-live] is a slot. The
   element's [data-tpl] attribute is a template string that is
   interpolated with the live values and written to textContent.

   Supported placeholders:
     {avg}     - average rating, formatted "4,83" (2 decimals, comma)
     {count}   - master-list count, formatted "1.650" (EU thousands)
     {rawcount} - count_total_raw incl. spam, EU thousands formatted

   Config source: window.ILS_REVIEWS_HOME.apiBase (already emitted
   by custom-reviews-home section and the PDP summary bootstrap).

   On fetch error / empty payload the Liquid fallback is preserved.
   ============================================================ */
(function () {
  'use strict';

  function formatAverage(n) {
    var v = parseFloat(n);
    if (!isFinite(v)) return '';
    return v.toFixed(2).replace('.', ',');
  }

  function formatThousandsDot(n) {
    var v = parseInt(n, 10);
    if (!isFinite(v)) return '';
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function applyTemplate(tpl, values) {
    if (typeof tpl !== 'string' || !tpl) return '';
    return tpl
      .replace(/\{avg\}/g, values.avg || '')
      .replace(/\{count\}/g, values.count || '')
      .replace(/\{rawcount\}/g, values.rawcount || '');
  }

  function paintAll(values) {
    var slots = document.querySelectorAll('[data-ils-store-rating-live]');
    if (!slots.length) return;
    slots.forEach(function (el) {
      var tpl = el.getAttribute('data-tpl') || '{avg}';
      var out = applyTemplate(tpl, values);
      if (out) el.textContent = out;
    });
  }

  function init() {
    var slots = document.querySelectorAll('[data-ils-store-rating-live]');
    if (!slots.length) return;

    var cfg = window.ILS_REVIEWS_HOME || {};
    var apiBase = (typeof cfg.apiBase === 'string' && cfg.apiBase)
      ? cfg.apiBase.replace(/\/+$/, '') : '';
    if (!apiBase) {
      if (window.console && console.warn) {
        console.warn('[ils-store-rating-live] no apiBase configured - keeping Liquid fallback.');
      }
      return;
    }

    fetch(apiBase + '/api/reviews/summary', { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || typeof data !== 'object') return;
        var values = {
          avg: formatAverage(data.average),
          count: formatThousandsDot(data.count),
          rawcount: formatThousandsDot(data.count_total_raw)
        };
        paintAll(values);
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ils-store-rating-live] fetch failed - keeping Liquid fallback.', err);
        }
      });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
